import SharingActions, { SharingMessage } from '@eversports/klimt-patterns/SharingActions'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import InviteFriends from '../../../../../components/InviteFriends'
import { Localized } from '../../../../../localization/react'

interface Props {
  sharingMessage: SharingMessage
  eventId: string
}

const ShareContent = ({ sharingMessage, eventId }: Props) => {
  return (
    <Stack gap={4}>
      <InviteFriends type="event" eventId={eventId} />
      <Heading is="h4" variant="small">
        <Localized id="share-it" />
      </Heading>
      <SharingActions sharingMessage={sharingMessage} />
    </Stack>
  )
}

export default ShareContent
